import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";

import { requestUpdateDriver } from "./updateDriver.request";
import { UpdateDriverResponseData } from "./updateDriver.types";

const useUpdateDriver = (
  options?: MutationOptions<UpdateDriverResponseData, ApiServiceError<ApiError>>
) => {
  const refetchDrivers = useRefetchQuery(["driver"]);

  return useMutation({
    mutationFn: requestUpdateDriver,
    ...options,
    onSuccess: (...args) => {
      refetchDrivers();
      options?.onSuccess?.(...args);
    }
  });
};

export default useUpdateDriver;
